import { useCallback } from "react";
import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

export const useClickRepeaterReservation = () => {
	/**
	 * 過去予約詳細への遷移（別タブ）
	 */
	const onClickRepeaterReservation = useCallback((targetHotelID: string, targetReservationID: string) => {
		const url = generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.DETAIL, {
			hotelID: targetHotelID,
			reservationID: targetReservationID,
		});
		window.open(url, "_blank");
	}, []);

	return {
		onClickRepeaterReservation,
	};
};
